import { createVNode as n, mergeProps as a } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FolderOpenTwotoneStandard.js";
import p from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(p, a(t, {
    icon: d
  }), null);
};
o.displayName = "FolderOpenTwotoneStandard";
o.inheritAttrs = !1;
export {
  o as default
};
